import {PTGC_SET_SELECTED_ELEMENTS} from './../../constants';

const setSelectedCalendars = (selectedElements) => ({
    type: PTGC_SET_SELECTED_ELEMENTS,
    selectedElements
});

export default setSelectedCalendars;